import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { getCheckrDashboardUrl } from "@src/appV2/Worker/utils/getCheckrDashboardUrl";
import { useOpenUrl } from "@src/mobile/utils/openUrl";
import { Button, Tooltip } from "antd";

interface ViewCheckrReportsButtonProps {
  email?: string;
}

export function ViewCheckrReportsButton(props: ViewCheckrReportsButtonProps) {
  const email = props.email?.trim();
  const openUrl = useOpenUrl();
  const canOpen = isDefined(email) && email.length > 0;

  const handleClick = () => {
    if (!canOpen) {
      return;
    }
    logEvent(APP_V2_USER_EVENTS.WORKER_CHECKR_REPORTS_VIEWED);
    void openUrl(getCheckrDashboardUrl(email));
  };

  const tooltipTitle = canOpen
    ? "Opens the Checkr admin dashboard filtered by this worker's email — useful for looking up their background-check reports."
    : "Add an email to this worker to enable Checkr lookup.";

  return (
    <Tooltip title={tooltipTitle}>
      {/* span wrapper lets the Tooltip receive mouse events when the Button is disabled (antd v4) */}
      <span>
        <Button disabled={!canOpen} onClick={handleClick}>
          View Checkr reports
        </Button>
      </span>
    </Tooltip>
  );
}
